import { asyncAction } from 'lib/actionCreators'
import { createRoutine } from 'redux-saga-routines'

export const assocSkillsList = asyncAction('manager/GET_ASSOC_SKILL_LIST')
export const assocSkillData = asyncAction('manager/GET_ASSOC_SKILL_DATA')
export const postAssocSkillData = createRoutine('manager/POST_ASSOC_SKILL')
export const deleteAssocSkillItem = createRoutine('manager/DELETE_ASSOC_SKILL_ITEM')
